module.exports = "//static.hsappstatic.net/conversations-visitor-experience-components/static-1.595/img/visitor-widget/launcher-close-icon-dark.svg"